export const DOCUMENT_CONSTANTS = Object.freeze({
  ADVANCED_FUNDS_LIST: Object.freeze({
    ALL_OR_USER_FUNDS_FILTER_TITLE: '0. Ansicht',
    FUNDS_ALL: 'ALLE',
    FUNDS_USER: 'EIGENE',
  }),
});
